var $b6a57900aad4b8a7$exports = {};
$b6a57900aad4b8a7$exports = {
    "endTime": `\u{C885}\u{B8CC} \u{C2DC}\u{AC04}`,
    "startTime": `\u{C2DC}\u{C791} \u{C2DC}\u{AC04}`,
    "time": `\u{C2DC}\u{AC04}`
};


export {$b6a57900aad4b8a7$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
